export default __webpack_public_path__ + "static/media/wsa.d47db44a.png";